import { render } from "./EditProiectTaskDetail.vue?vue&type=template&id=5f85cc12&scoped=true&ts=true"
import script from "./EditProiectTaskDetail.ts?vue&type=script&lang=ts&external"
export * from "./EditProiectTaskDetail.ts?vue&type=script&lang=ts&external"

import "./EditProiectTaskDetail.vue?vue&type=style&index=0&id=5f85cc12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f85cc12"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QSpinner,QBtn,QMenu,QExpansionItem,QTable,QTooltip,QSpace,QInput,QIcon,QTr,QTd,QDialog,QCard,QBar,QCardSection,QField});qInstall(script, 'directives', {ClosePopup});
